import * as React from "react"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import AddAccural from "./AddAccrual"
import strings from "../../localization/strings"
import { EAccrualType, IAccrual } from "../../models"
import autobind from "class-autobind"
import { green500, red500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import TableActionBar from "../../components/layout/TableActionBar"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AppStateStore from "../../stores/AppStateStore"
import _ from "lodash"
interface IProps {
  accruals: IAccrual[]
  addAccrual(accrual: IAccrual, cb?: () => void): void
  updateAccrual(accrual: IAccrual, cb?: () => void): void
  deleteAccrual(accrualId: string, cb?: (deleteResult: boolean) => void): void
}
interface IState {
  searchedAccrulas: IAccrual[]
  selectedAccrual: IAccrual
  openAddAccrual: boolean
  editAccrual: IAccrual
  searchText: string
}
interface IStyles {
  columnValue: React.CSSProperties
  noAccruals: React.CSSProperties
}
const styles: IStyles = {
  columnValue: {
    textAlign: "center",
    cursor: "pointer",
    whiteSpace: "normal"
  },
  noAccruals: {
    textAlign: "center",
    fontSize: 25,
    paddingTop: 50,
    fontWeight: "bold" as "bold"
  }
}
export default class Accruals extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      searchedAccrulas: [],
      selectedAccrual: null,
      openAddAccrual: false,
      editAccrual: null,
      searchText: "",
    }
    autobind(this)
  }

  componentDidMount() {
    this.setState({
      searchedAccrulas: this.props.accruals,
      selectedAccrual: null,
    })
  }

  componentWillReceiveProps(nextProps) {
    !_.isEqual(this.props.accruals, nextProps.accruals) &&
      this.setState({
        searchedAccrulas: nextProps.accruals,
        selectedAccrual: null,
        searchText: ""
      })
  }

  handleSelectAccrual(rowNumber, colId) {
    if (colId === -1) {
      permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.DeleteAccrual) &&
        this.setState({ selectedAccrual: this.state.selectedAccrual && this.state.selectedAccrual.Id === this.state.searchedAccrulas[rowNumber].Id ? null : this.state.searchedAccrulas[rowNumber] })
    }
    else {
      permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.EditAccrual) &&
        this.setState({ openAddAccrual: true, editAccrual: this.state.searchedAccrulas[rowNumber] })
    }
  }

  addAccrual(accrual: IAccrual) {
    this.setState({ openAddAccrual: false })
    this.props.addAccrual(accrual, () => {
      AppStateStore.setProgressSnackbarContent(strings.Accrual_created_successfully)
      this.setState({ searchText: "", selectedAccrual: null })
    })
  }

  updateAccrual(accrual: IAccrual) {
    this.setState({ openAddAccrual: false })
    this.props.updateAccrual(accrual, () => {
      AppStateStore.setProgressSnackbarContent(strings.Accrual_updated_successfully)
      this.setState({ selectedAccrual: null, searchText: "" })
    })
  }

  handleSearch(searchText) {
    const searchedAccrulas = this.props.accruals.slice().filter((accrual) => {
      return accrual.Name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
    })
    this.setState({ searchText, selectedAccrual: null, searchedAccrulas })
  }

  render() {
    return (
      <div>
        {permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.AddAccrual) &&
          <FloatingActionButton
            data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Btn-Add"}
            className="fixed-add"
            style={{ top: -28, right: 20 }}
            secondary={true}
            onTouchTap={() => this.setState({ openAddAccrual: true, editAccrual: null })}
          >
            <ContentAdd />
          </FloatingActionButton>
        }
        <div style={{ paddingTop: 30 }}>
          <TableActionBar
            searchText={this.state.searchText}
            onSearch={this.handleSearch}
            rowSelectionCount={this.state.selectedAccrual ? 1 : 0}
            singleSelectedMessage={strings.Accrual_Selected}
            title={strings.Accruals}
            titleStyle={{ fontSize: 16 }}
            bodyStyle={{ padding: 20, fontWeight: 500 }}
            onDeleteClick={() =>
              AppStateStore.setConfirmDialogContent({
                title: strings.Delete_Accrual,
                content: strings.Are_you_sure_delete_accrual,
                confirm: () => this.props.deleteAccrual(this.state.selectedAccrual.Id, (deleteResult = true) => {
                  AppStateStore.setProgressSnackbarContent(deleteResult ? strings.Accrual_removed_successfully : strings.Cannot_delete_Accrual_used_for_Employee_Accrual)
                  this.setState({ selectedAccrual: null, searchText: "" })
                })
              })
            }
          />
          <div style={{ maxHeight: 250, overflowY: "auto" }}>
            {this.state.searchedAccrulas.length === 0 ?
              <h2 style={styles.noAccruals}>{strings.No_Accrual}</h2> :
              <Table onCellClick={this.handleSelectAccrual} selectable={permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.DeleteAccrual)}>
                <TableHeader>
                  <TableRow>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Accrual_Name}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Accrual_Code}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Type}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Rate}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Min_Balance}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Max_Balance}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Use_for_Leave_Tracking}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnValue}>{strings.Leave_Tracking_Pay_Type}</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody deselectOnClickaway={false}>
                  {this.state.searchedAccrulas.map((accrual, key) => {
                    const payType = accrual.PayTypeIdUsedForLeavePunchSet && AccountStore.getCurrentAccount().PayTypes.find(item => item.Id === accrual.PayTypeIdUsedForLeavePunchSet)
                    return (
                      <TableRow data-intercom-target={key === 0 && "menu-AccountSettings-PayConfiguration-AccrualsTab-openItemDetails"} selected={this.state.selectedAccrual && this.state.selectedAccrual.Id === accrual.Id} key={key}>
                        <TableRowColumn style={styles.columnValue}>{accrual.Name}</TableRowColumn>
                        <TableRowColumn style={styles.columnValue}>{accrual.Code}</TableRowColumn>
                        <TableRowColumn style={styles.columnValue}>{accrual.Type !== EAccrualType.Monetary ? (accrual.Type === EAccrualType.PerHourWorked ? strings.Per_Hour_Worked : strings.Per_Day) : "Monetary"}</TableRowColumn>
                        <TableRowColumn style={styles.columnValue}>{accrual.Type !== EAccrualType.Monetary ? (accrual.ContributingRatePerHour) : ""}</TableRowColumn>
                        <TableRowColumn style={styles.columnValue}>{accrual.Type !== EAccrualType.Monetary ? (accrual.MinBalance) : ""}</TableRowColumn>
                        <TableRowColumn style={styles.columnValue}>{accrual.Type !== EAccrualType.Monetary ? (accrual.MaxBalance) : ""}</TableRowColumn>
                        <TableRowColumn style={styles.columnValue}>
                          {accrual.AllowUseForLeaveTracking && <div><i style={{ fontSize: 22, color: green500 }} className="fa fa-check" /></div>}
                        </TableRowColumn>
                        <TableRowColumn style={styles.columnValue}>
                          <span style={{ color: accrual.PayTypeIdUsedForLeavePunchSet && !payType && red500 }}>
                            {accrual.PayTypeIdUsedForLeavePunchSet && (payType ? payType.Name : strings.PayType_Removed)}
                          </span>
                        </TableRowColumn>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            }
          </div>
        </div>
        {this.state.openAddAccrual &&
          <AddAccural
            existingAccruals={this.props.accruals}
            editAccrual={this.state.editAccrual}
            handleClose={() => this.setState({ openAddAccrual: false, editAccrual: null })}
            handleAdd={this.addAccrual}
            handleUpdate={this.updateAccrual}
          />
        }
      </div>
    )
  }
}
